import { render, staticRenderFns } from "./RelatorioDividasCashPosto.vue?vue&type=template&id=1a671c65&"
import script from "./RelatorioDividasCashPosto.vue?vue&type=script&lang=js&"
export * from "./RelatorioDividasCashPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports